import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const MentionsLegales = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navbar />
      
      <div className="pt-32 pb-16 bg-gradient-to-b from-neutral-900 to-black">
        <div className="max-w-4xl mx-auto px-4 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-400 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft size={20} />
            Retour
          </Link>

          <h1 className="font-display text-5xl md:text-6xl font-bold uppercase text-white mb-12 tracking-wide">
            Mentions Légales
          </h1>

          <div className="space-y-8">
            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <p className="text-gray-300 leading-relaxed mb-6">
                Les notes légales sont actuellement liées au site <strong className="text-white">Gail Lleyton</strong>.
              </p>
              <p className="text-gray-300 leading-relaxed">
                Notre site internet est mise en ligne pour avoir plus d'information sur notre domaine et notre travail.
              </p>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                1. DÉNOMINATION SOCIALE
              </h2>
              <div className="text-gray-300 space-y-2">
                <p><strong className="text-white">Gail Lleyton</strong></p>
                <p className="italic">Paris – Ile de France (France)</p>
                <p>Siret : 493 981 708 00016</p>
                <p>Mail : <a href="mailto:Contact@gaillleyton.com" className="text-rose-400 hover:text-rose-300">Contact@gaillleyton.com</a></p>
              </div>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                2. WEB MASTER
              </h2>
              <div className="text-gray-300 space-y-2">
                <p><strong className="text-white">Gail Lleyton</strong></p>
                <p className="italic">Paris – Ile de France (France)</p>
                <p>Mail : <a href="mailto:Contact@gaillleyton.com" className="text-rose-400 hover:text-rose-300">Contact@gaillleyton.com</a></p>
              </div>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                3. CHARTE ÉDITORIALE
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Le site Web de Gail Lleyton est un site de présentation des activités de Gail Lleyton.
                Les informations fournies dans ce site ne sont données qu'à titre indicatif.
              </p>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                4. DONNÉES PERSONNELLES
              </h2>
              <div className="text-gray-300 leading-relaxed space-y-4">
                <p>
                  Les informations que vous entrerez seront enregistrées par <strong className="text-white">Gail Lleyton</strong>.
                </p>
                <p>
                  Vous disposez d'un droit d'accès, de modification, de rectification et de suppression concernant les données collectées sur ce site, dans les conditions prévues par la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés.
                </p>
                <p>
                  Pour l'exercer, adressez-vous par courrier au gestionnaire du site, à l'adresse suivante : <strong className="text-white">Gail Lleyton</strong>, <em className="italic">Paris – Ile de France (France)</em>, <a href="mailto:Contact@gaillleyton.com" className="text-rose-400 hover:text-rose-300">Contact@gaillleyton.com</a>.
                </p>
              </div>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                5. LIENS HYPERTEXTES
              </h2>
              <p className="text-gray-300 leading-relaxed">
                La création de liens hypertextes vers le site Gail Lleyton est soumis à l'accord préalable du Directeur de la Publication. Les liens hypertextes établis en direction d'autres sites à partir du site Gail Lleyton ne sauraient, en aucun cas, engager la responsabilité de Gail Lleyton.
              </p>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                6. INFORMATIONS TECHNIQUES
              </h2>
              <p className="text-gray-300 leading-relaxed">
                Il est rappelé que le secret des correspondances n'est pas garanti sur le réseau Internet et qu'il appartient à chaque utilisateur d'Internet de prendre toutes les mesures appropriées de façon à protéger ses propres données et/ou logiciels de la contamination d'éventuels virus circulant sur Internet.
              </p>
            </div>

            <div className="bg-neutral-900/50 border border-neutral-800 rounded-2xl p-8">
              <h2 className="font-display text-3xl font-bold text-white mb-4 uppercase tracking-wide">
                7. DROITS D'AUTEURS
              </h2>
              <div className="text-gray-300 leading-relaxed space-y-4">
                <p>
                  Aucune exploitation commerciale même partielle des données qui y sont présentées ne pourra être effectuée sans l'accord préalable et écrit de Gail Lleyton.
                </p>
                <p>
                  Le nom et les logos des produits sont la propriété de Gail Lleyton.
                </p>
                <p>
                  Toute reproduction, utilisation et/ou modification qui en serait faite sans l'accord préalable et écrit de Gail Lleyton, est susceptible d'en constituer la contrefaçon. Elle n'engagera par ailleurs d'aucune manière la responsabilité de Gail Lleyton.
                </p>
                <p>
                  Les photographies, images, textes et autres documentations représentées sur le présent site Internet sont objet de droits de propriété industrielle et/ou intellectuelle, propriétés de Gail Lleyton.
                </p>
                <p>
                  A ce titre, toute reproduction, représentation, adaptation, traduction, et/ou transformation, partielle ou intégrale, ou transfert sur un autre site sont interdits. Les renseignements et présentations contenus dans les pages de ce site sont fournis à titre purement indicatif et restent susceptibles de modifications à tout moment et sans préavis. En conséquence, Gail Lleyton décline toute responsabilité :
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site ;</li>
                  <li>pour tous dommages, directs et/ou indirects, qu'elles qu'en soient les causes, origines, natures ou conséquences, provoquées à raison de l'accès de quiconque au site ou de l'impossibilité d'y accéder, de même que l'utilisation du site et/ou du crédit accordé à une quelconque information provenant directement ou indirectement du site ;</li>
                  <li>pour tout usage qui pourra être fait de ces différentes informations.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MentionsLegales;
